import { render } from "./ProjectsForm.vue?vue&type=template&id=c0d560ec&scoped=true"
import script from "./ProjectsForm.vue?vue&type=script&lang=js"
export * from "./ProjectsForm.vue?vue&type=script&lang=js"

import "./ProjectsForm.vue?vue&type=style&index=0&id=c0d560ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d560ec"]])

export default __exports__